
import { environment as environmentProd } from './environment.prod';

export const environment = {
  production: false
};
